import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

const BASE = "/organization-questionnaires";
const SUFFIX = "/purchased-goods-and-services/water-usage/items";
const TEMPLATE_FILE_NAME = "Scope3_Category1_water_usage_template.xlsx";

const api = {
  getPurchasedGoodsWaterUsageItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`${BASE}/${params.questionnaireId}${SUFFIX}`, config).then(({ data }) => data);
  },

  addPurchasedGoodsWaterUsageItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`${BASE}/${questionnaireId}${SUFFIX}`, data, headers).then(({ data }) => data);
  },

  updatePurchasedGoodsWaterUsageItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`${BASE}/${questionnaireId}${SUFFIX}/${recordId}`, data, headers).then(({ data }) => data);
  },

  deletePurchasedGoodsWaterUsageItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`${BASE}/${questionnaireId}${SUFFIX}/${recordId}`, headers).then(({ data }) => data);
  },

  importPurchasedGoodsWaterUsageItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`${BASE}/${questionnaireId}${SUFFIX}/import`, data, headers).then(({ data }) => data);
  },

  getTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`${BASE}/${questionnaireId}${SUFFIX}/template`, config)
      .then(({ data, headers }) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        const defaultFileName = parseContentDispositionFilename(
          headers["content-disposition"], TEMPLATE_FILE_NAME);
        link.href = url;
        link.setAttribute("download", defaultFileName);
        document.body.appendChild(link);
        link.click();
        return true;
      });
  }
};

export default api;
